import { useState } from 'react'
import { Trans, useTranslation } from 'react-i18next'

import {
  AUTHORITY_SKILLS_OPTIONS,
  AUTHORITY_SKILLS_QUESTION,
} from '~/pages/communication/authoritySkills/libs/components/AuthoritySkillsCommunication/constants'
import { CommunicationSingleSelectStyles as S } from '~/pages/communication/libs/communicationSingleSelectStyles'
import { parseEmojiOption } from '~/pages/communication/libs/parseEmojiOption'
import { useDelayedContinue } from '~/shared/hooks/useDelayedContinue'
import { useNextStep } from '~/shared/hooks/useNextStep'
import { TPageProps } from '~/shared/types/commonTypes'

const AuthoritySkillsCommunication = ({ nextPagePath, pageId }: TPageProps) => {
  const { t } = useTranslation('communication')
  const [answer, setAnswer] = useState('')
  const { isAnswersDisabled, handleChange, setIsAnswersDisabled } =
    useDelayedContinue()

  const handleContinue = useNextStep({
    nextPagePath,
    pageId,
    pageName: pageId,
    question: AUTHORITY_SKILLS_QUESTION,
  })

  return (
    <S.Root>
      <S.ContentWrapper>
        <S.TitleGroup>
          <S.Title>
            <Trans
              ns="communication"
              i18nKey="onboarding.communicationAuthoritySkills.title"
            />
          </S.Title>
        </S.TitleGroup>

        <S.Options>
          {AUTHORITY_SKILLS_OPTIONS.map(({ key, i18nKey }) => {
            const { emoji, label } = parseEmojiOption(
              t(`onboarding.communicationAuthoritySkills.options.${i18nKey}`),
            )

            return (
              <S.OptionButton
                key={key}
                type="button"
                $isSelected={answer === key}
                disabled={isAnswersDisabled}
                onClick={() => {
                  if (isAnswersDisabled) return
                  setAnswer(key)
                  handleChange(key, handleContinue)
                  setIsAnswersDisabled(true)
                }}
              >
                <S.OptionEmoji>{emoji}</S.OptionEmoji>
                <S.OptionLabel>{label}</S.OptionLabel>
              </S.OptionButton>
            )
          })}
        </S.Options>
      </S.ContentWrapper>
    </S.Root>
  )
}

export default AuthoritySkillsCommunication
